"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeMarkBasedComparisonSpec = void 0;
var makeMarkBasedComparisonSpec = function (message, numberOfMarks) {
    return {
        type: 'MARK_BASED_COMPARISON',
        numberOfMarks: numberOfMarks !== null && numberOfMarks !== void 0 ? numberOfMarks : 1,
        message: message,
    };
};
exports.makeMarkBasedComparisonSpec = makeMarkBasedComparisonSpec;
//# sourceMappingURL=MarkBasedComparisonSpec.js.map